import { render, staticRenderFns } from "./VideoHoverPlayer.vue?vue&type=template&id=4e0fedee&scoped=true"
import script from "./VideoHoverPlayer.vue?vue&type=script&lang=js"
export * from "./VideoHoverPlayer.vue?vue&type=script&lang=js"
import style0 from "./VideoHoverPlayer.vue?vue&type=style&index=0&id=4e0fedee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e0fedee",
  null
  
)

export default component.exports